import { getFormattedDateReverse } from '../../utils/date';
import handleChange from '../../utils/handleChange';
import Tooltip from '../tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../assets/icons/trvto_info.svg';
import './dropdown.css';
import { truncateText } from '../../utils/maskFields';

export default function Dropdown({
    label,
    name,
    options,
    value,
    req,
    setFormData,
    className,
    disabled,
    infoIcon,
    infoContent,
    parentKey
}) {
    return (
        <div className={`dropdownDiv ${className}`}>
            <div className='dropdownLabelText'>
                <label className='dropdownlabel'>{label}</label>
                {infoIcon && (
                    <Tooltip content={infoContent} position='top'>
                        <span className='eyeIcon'>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                )}
            </div>
            <select
                value={value}
                name={name}
                onChange={(e) => handleChange(e, setFormData, parentKey)}
                required={req}
                className='dropdownSelect'
                disabled={disabled}
            >
                <option value='-1'>Select</option>
                {options?.map(function (val, typeIndex) {
                    return (
                        <option key={typeIndex} value={val} title={val}>
                            {truncateText(val, 40)}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}

export function Dropdown2({
    label,
    name,
    options,
    value,
    req,
    setFormData,
    className,
    disabled,
    infoIcon,
    infoContent
}) {
    return (
        <div className={`dropdownDiv ${className}`}>
            <div className='dropdownLabelText'>
                <label className='dropdownlabel'>{label}</label>
                {infoIcon && (
                    <Tooltip content={infoContent} position='top'>
                        <span className='eyeIcon'>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                )}
            </div>
            <select
                value={value}
                name={name}
                onChange={(e) => handleChange(e, setFormData)}
                required={req}
                className='dropdownSelect'
                disabled={disabled}
            >
                <option value='-1'>Select</option>
                {options?.map(function (val, typeIndex) {
                    return (
                        <option key={typeIndex} value={val.value}>
                            {val.name}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}
export function Dropdown1({
    label,
    name,
    options,
    value,
    req,
    setFormData,
    className,
    handleSelectedDate,
    icon,
    disabled
}) {
    return (
        <div className={`dropdownDiv ${className}`}>
            <label className='dropdownlabel'>
                <span className='icon'>{icon}</span>
                <span>{label}</span>
            </label>
            <select
                value={value ?? ''}
                name={name}
                onChange={(e) => {
                    handleChange(e, setFormData);
                    handleSelectedDate(e.target.value);
                }}
                required={req}
                className='dropdownSelect'
                disabled={disabled}
            >
                <option value='-1'>Select</option>
                {options?.map(function (val, typeIndex) {
                    return (
                        <option key={typeIndex} value={val}>
                            {getFormattedDateReverse(val)}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}
